import { Ellipsis } from '@/components/Ellipsis';
import { Box, Checkbox, Radio } from '@mui/material';
import React from 'react';
import { CustomLabelProperties } from './types';

export const CustomLabel: React.FC<CustomLabelProperties> = ({
  label,
  count,
  filterValue,
  enableMultiSelect,
  checked,
  indeterminate = false,
  onToggle,
}) => (
  <Box
    onClick={event => {
      event.stopPropagation();
      onToggle(filterValue);
    }}
    sx={{ display: 'flex', alignItems: 'center', minWidth: 0, overflow: 'hidden' }}
  >
    {enableMultiSelect ? (
      <Checkbox
        checked={checked}
        indeterminate={indeterminate}
        onClick={event => {
          event.stopPropagation();
          onToggle(filterValue);
        }}
        size='small'
      />
    ) : (
      <Radio
        checked={checked}
        onClick={event => {
          event.stopPropagation();
          onToggle(filterValue);
        }}
        size='small'
      />
    )}
    <Ellipsis text={label} />
    {count !== undefined && (
      <span style={{ marginLeft: 4, flexShrink: 0, color: 'inherit', opacity: 0.6 }}>({count})</span>
    )}
  </Box>
);
